import { Price, PriceLevel, Text, TextLevels } from '@bytel/trilogy-react';

import { familyAdvantagesPredicate } from '@services/mcube';

import { Contract } from '@app-types/simulator/simulator';

import { formatPhoneNumber } from '@helpers/phone-number';

import { OfferItemBlock } from './offer-item-block';

export function CurrentContract({ contract }: { contract: Contract }) {
    return (
        <OfferItemBlock>
            <Text marginless level={TextLevels.TWO}>
                {formatPhoneNumber(contract.msisdn || contract.voipNumber) || contract.applicableOp?.commercialLabel}
            </Text>
            <Price
                level={PriceLevel.SEVEN}
                amount={
                    contract.applicableOp.advantages?.filter(familyAdvantagesPredicate)[0]?.discountIncludingTax || 0
                }
                period='mois'
            />
        </OfferItemBlock>
    );
}
